import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

export const trackScheduleFlagChangesEvent = createTrackerForCategory('Schedule Changes');
